export const CHECKBOX_INPUT_VALIDATION_CLASSES = {
  error: 'd-checkbox--error',
  warning: 'd-checkbox--warning',
  success: 'd-checkbox--success',
};

export default {
  CHECKBOX_INPUT_VALIDATION_CLASSES,
};
